"use strict";

export const LUM_THRESHOLD = 0.03928;
export const PERCEPTIVE_FACTOR_RED = 0.2126;
export const PERCEPTIVE_FACTOR_GREEN = 0.7152;
export const PERCEPTIVE_FACTOR_BLUE = 0.0722;

const colorRegExp = /^(#)?([0-9a-f]+)$/i;

function checkColor(color)
{

    const m = colorRegExp.exec(String(color));
    if (!m)
    {
        return null;
    }
    const col = m[2];

    if (col.length == 3)
    {
        return {
            r: parseInt(col[0], 16) / 15,
            g: parseInt(col[1], 16) / 15,
            b: parseInt(col[2], 16) / 15
        };
    }
    else if (col.length == 6)
    {
        return {
            r: parseInt(col.substring(0, 2), 16) / 255,
            g: parseInt(col.substring(2, 4), 16) / 255,
            b: parseInt(col.substring(4, 6), 16) / 255
        };
    }
    else
    {
        return null;
    }
}


function gun_luminance(v)
{

    if (v <= LUM_THRESHOLD)
    {
        return v / 12.92
    }
    else
    {
        return Math.pow(((v + 0.055) / 1.055), 2.4);
    }
}

function hex(n)
{
    const s = n.toString(16);

    return s.length == 1 ? "0" + s : s;
}

export function components(color)
{
    let col = checkColor(color);
    if (!col)
    {
        throw new Error("Invalid color " + color);
    }
    return col;
}

export function isColor(color)
{
    const col = checkColor(color);
    return col && !isNaN(col.r) && !isNaN(col.g) && !isNaN(col.b);
}

export function getLuminance(color)
{
    const c = components(color);
    return PERCEPTIVE_FACTOR_RED * gun_luminance(c.r) + PERCEPTIVE_FACTOR_GREEN * gun_luminance(c.g) + PERCEPTIVE_FACTOR_BLUE * gun_luminance(c.b);
}

export function contrast(colorA, colorB)
{
    let h;
    let lum1 = getLuminance(colorA);
    let lum2 = getLuminance(colorB);

    if (lum1 < lum2)
    {
        h = lum1;
        lum1 = lum2;
        lum2 = h;
    }

    const contrast = (lum1 + 0.05) / (lum2 + 0.05);

//        console.debug("contrast: %o", contrast);

    return contrast;
}

export function mix(col1, col2, ratio)
{
    const c1 = components(col1);
    const c2 = components(col2);

    const r = (c1.r + (c2.r - c1.r) * ratio) | 0;
    const g = (c1.g + (c2.g - c1.g) * ratio) | 0;
    const b = (c1.b + (c2.b - c1.b) * ratio) | 0;

    return rgb(r, g, b);
}

export function rgb(r, g, b)
{
    return "#" + hex(r) + hex(g) + hex(b);
}

export function fade(color, opacity)
{
    const col = components(color);
    return "rgba(" + col.r + ", " + col.g + ", " + col.b + ", " + opacity + ")";
}



// WEBPACK FOOTER //
// ./src/util/color.js